import getCombatantSlots from './getCombatantSlots'

export default async function getCombatantNextRoundAction(combatant, round) {
  if (!combatant?.slug || !Number.isFinite(round)) {
    return null
  }

  const slots = await getCombatantSlots(combatant.slug)
  const nextRound = round + 1
  const actions = Array.isArray(slots?.actions) ? slots.actions : []

// const nextAction = actions
//     .filter(
//       (action) =>
//         action?.round === nextRound &&
//         Number.isFinite(action?.number) &&
//         action?.action_name !== 'pending' &&
//         action?.action_name !== 'blank',
    // )

  const nextAction = actions
    .filter(
      (action) =>
        action?.round === nextRound &&
        action?.number == 1 &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank',
    )
    .sort((left, right) => left.number - right.number)[0]

  return nextAction || null
}
